<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="topImg bg-contain"></div>
            <div class="topimg bg-100"></div>
            <div class="r16 oilCardWrap">
                <zbSwiper
                    ref="swiper"
                    :options="swiperOptions"
                    :data="cardList"
                    :isCustom="true"
                    designWidth="670"
                    designHeight="240"
                    @activateItemChange="onActivateChange"
                    class="shadow-bg r16 swipe"
                >
                    <van-swipe-item
                        v-for="(item, index) in cardList"
                        :key="index"
                        class="r16 bv bc"
                    >
                        <div class="infoWrap bh">
                            <div class="ico-oilEdit logo bg-contain"></div>
                            <div class="rightInfo">
                                <div class="delWrap" @click="deletOilCard(item.id)">
                                    <div class="del ico-cardDel bg-contain"></div>
                                </div>
                                <p class="fz_34 oilTitle">中国石化</p>
                                <div class="cardNum fz_36">{{item.number|cardNumber}}</div>
                                <div class="fz_30 c_333">持卡人：{{item.ownerName}}</div>
                            </div>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item class="r16" v-if="cardList.length<=2">
                        <div class="addCard bh bstart" @click="go('FeeOilEdit')">
                            <div class="cardLogo ico-oilEdit bg-contain"></div>
                            <div class="text">
                                <p class="add c_black fz_36">点击添加油卡</p>
                                <p class="support c_999 fz_24">仅支持中石化加油卡</p>
                            </div>
                            <div class="bgLogo ico-oilEditBg bg-contain"></div>
                        </div>
                    </van-swipe-item>
                </zbSwiper>
            </div>
            <div class="selectInfo">
                <van-tabs swipeable>
                    <van-tab
                        v-for="(item, index) in store.data"
                        :key="index"
                        :title="item.name"
                        :name="item.id"
                    >
                        <oilList
                            :typeId="item.id"
                            :listId="listId"
                            :typeName="item.name"
                            @buy="onBuyClick"
                        ></oilList>
                    </van-tab>
                </van-tabs>
            </div>
            <div class="footerText bh bc fz_28 c_999">
                <div class="record" @click="go('UserOrder')">充值记录</div>
                <div class="problem" @click="go('DealInfo',{data:'oilProblems',title:'常见问题'})">常见问题</div>
            </div>
        </div>
    </div>
</template>
<script>
import zbSwiper from "@/components/swiper/Container";
import oilList from "./List";
import { saveOrder } from "@/api/cart";
import { typeList, delOilCard } from "@/api/fee";
import { user } from "@/mixin/user";
import { list } from "@/mixin/list";
import util from "@/utils/index";

export default {
    name: "FeeOilHome",
    mixins: [user, list],
    components: { zbSwiper, oilList },
    data() {
        return {
            swiperOptions: {
                loop: false
            },
            // 油卡充值价格列表
            data: [],
            // 当前选中id
            oilCardId: -1,
            // 重置方式
            store: {
                proxy: {
                    getList: typeList,
                    disposeItem: function(item) {
                        item.name = item.name.replace("油卡", "");
                    }
                }
            },
            // 当前选中油卡id
            listId: "",
            // 当前选中油卡卡号
            listNum: "",
            // 当前选中油卡姓名
            listName: ""
        };
    },
    filters: {
        cardNumber: function(val) {
            return val.replace(/(.{4})/g, "$1 ");
        }
    },
    methods: {
        // 获取数据
        userLoginend() {
            const me = this;
            // 获取油卡列表
            me.$store.dispatch("fee/oilCardList");
            // 获取充值方式
            me.storeLoad();
        },
        // 滑动切换油卡时，改变油卡id
        onActivateChange(data) {
            const me = this;
            let id = "",
                name = "",
                num = "";
            if (data) {
                id = data.id;
                num = data.number;
                name = data.ownerName;
            }
            me.listId = id.toString();
            me.listNum = num;
            me.listName = name;
            me.$store.state.fee.oilCardId = id;
            // console.log(id, this.listNum, this.listName);
        },
        // 删除油卡
        deletOilCard(id) {
            const me = this;
            me.dialog
                .confirm(
                    {
                        title: "温馨提示",
                        message: "确认删除吗？",
                        confirmButtonText: "确定",
                        cancelButtonText: "取消"
                    },
                    true
                )
                .then(res => {
                    delOilCard(id).then(res => {
                        me.$store.dispatch("fee/oilCardList", true);
                    });
                })
                .catch(() => {
                    return;
                });
        },
        // 确认充值
        onBuyClick(goodId, listId, telephone, isIphone) {
            console.log(goodId, listId, isIphone, telephone);
            const me = this;
            let pro = "";
            if (isIphone) {
                pro = me.dialog.alert(
                    {
                        title: "提示",
                        message: "充值成功后需到订单详情页面进行兑换",
                        confirmButtonText: "知道了"
                    },
                    true
                );
            } else {
                pro = me.dialog.confirm(
                    {
                        title: "温馨提示",
                        message: `确认给卡号${this.listNum}(${this.listName})充值吗？`,
                        confirmButtonText: "确定",
                        cancelButtonText: "取消"
                    },
                    true
                );
            }
            pro.then(res => {
                // 生成订单
                saveOrder({
                    // 用户id
                    oilCardId: listId,
                    telephone: telephone,
                    fromCart: false,
                    // 商品信息
                    prepayGoodsList: [
                        {
                            goodsId: goodId,
                            num: 1
                        }
                    ],
                    orderType: 7
                }).then(res => {
                    // 调整到支付页面
                    me.go("CartOrderPay", res.data);
                });
            }).catch(() => {
                return;
            });
        }
    },
    computed: {
        cardList() {
            return this.$store.state.fee.oilCardList;
        },
        swipeData() {
            return { list: this.cardList, id: this.oilCardId };
        }
    },
    created() {
        // 页面显示时设置当前主键
        // 避免轮播主键位置不正确
        this.oilCardId = this.$store.state.fee.oilCardId;
    },
    activated() {
        // 页面激活时设置当前主键
        // 避免轮播主键位置不正确
        this.oilCardId = this.$store.state.fee.oilCardId;
    },
    watch: {
        // 取消充值返回时选中油卡
        swipeData(data) {
            const me = this,
                { id, list } = data;
            // console.log(data);
            if (id != -1) {
                const index = util.getListIndex(list, id);
                if (index != -1) {
                    me.listId = id.toString();
                    me.$refs.swiper.swipeTo(index);
                    // 重置选中油卡id
                    me.oilCardId = -1;
                }
            } else if (!list.length) {
                // 当没有油卡数据时，选中id置空
                me.listId = "";
            }
        }
    }
};
</script>

<style scoped lang="scss">
.topbar-container {
    background-color: #f7f8f8;
    .topImg {
        height: 210px;
        width: 100%;
        background-image: url("~@/assets/imges/fee/oilTop.png");
    }
    .oilCardWrap {
        position: relative;
        margin: -70px 0 0 40px;
        width: 670px;
        .swipe {
            position: initial;
            /deep/.van-swipe__indicators {
                bottom: -30px;

                .van-swipe__indicator {
                    background: #aaa;
                }
            }
        }
        // /deep/ .van-seipe-item {
        //     padding: 40px 0 40px 26px;
        // }
        .infoWrap {
            width: 100%;
            .logo {
                height: 60px;
                width: 57px;
                margin: 0 18px 0 26px;
            }
            .rightInfo {
                width: 100%;
                .oilTitle{
                    margin: 0px;
                }
                .cardNum{
                    padding: 18px 0;
                }
                .delWrap {
                    position: absolute;
                    right: 0px;
                    top: 0px;
                    padding: 30px;
                    .del {
                        height: 30px;
                        width: 30px;
                    }
                }
            }
        }
        .addCard {
            position: relative;
            padding: 30px 70px;
            .cardLogo {
                margin: 30px 20px 0 0;
                height: 106px;
                width: 102px;
            }
            .add{
                margin:0;
                padding: 36px 0 10px 0;
            }
            .support{
                margin:0;
            }
            .bgLogo {
                position: absolute;
                bottom: 0;
                right: 60px;
                height: 158px;
                width: 152px;
            }
        }
    }
    .selectInfo {
        margin-top: 80px;
        background-color: #fff;
        /deep/ .van-tabs__wrap {
            padding: 20px 0 0 0;
            /deep/ .van-tab__text {
                font-size: 32px;
            }
        }
    }
    .footerText {
        padding: 110px 0 50px 0;
        div {
            padding: 0 22px;
        }
        .record {
            border-right: 1px solid #999;
        }
    }
}
.cardNum {
    color: #ff9a2b;
}
[data-theme="app"] {
    .topbar-container {
        .topImg {
            background-image: url("~@/assets/imges/app/fee/oilTop.png");
        }
    }
    .cardNum {
        color: #c30d23;
    }
}
</style>